export enum PacklinkAuthAction {
  Login = 'LOGIN',
  Register = 'REGISTER',
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/packlink_auth_action.ts